$ = jQuery; // in case of no-conflict jquery

primitive.site = new primitive.PrimitiveSite({ // config data
  cartDataBaseURL: 'https://primitiveskate.com',
  //slowCartAjax: true,
  //fakeCartAjax: true,
  cartAjaxEnabled: true,
  
  searchSuggestURL: 'https://primitiveskate.com/search/suggest',
  searchSuggestSectionId: 'primitive-search-suggest',
  
  supportEmail: 'support@primitiveskate.com', // make this configurable
  
  intlTelUtilsScript: '//primitiveskate.com/cdn/shop/t/285/assets/intlTelInputUtils.js?v=106908025507378064141781678850'
  
});

// on page loaded
$(function() {
  primitive.site.init();
});